'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Filters;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _containers = require('containers');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Filters(props, _ref) {
  var _this = this;

  var polyglot = _ref.polyglot;
  var action = props.action,
      clear = props.clear;


  return _react2.default.createElement(
    'nav',
    { id: 'filters', className: 'Filters' },
    _react2.default.createElement(_containers.CalendarContainer, null),
    _config2.default.app.show.recurrencesButton && _react2.default.createElement(
      _caligramReact.HeadingBlock,
      { title: polyglot.t('event.recurringEvents') },
      _react2.default.createElement(_containers.RecurrencesButtonContainer, null)
    ),
    _config2.default.app.filtersEntitiesOrder.map(function (entity) {
      if (_config2.default.app.entities[entity].inFilters) {
        return _react2.default.createElement(
          _caligramReact.HeadingBlock,
          { key: 'filters' + (0, _utils.capitalize)(entity), className: entity, title: polyglot.t('event.entities.' + entity) },
          _react2.default.createElement(_caligramReact.SelectionList, { available: props[entity], selected: props['selected' + (0, _utils.capitalize)(entity)], groupKey: 'none', clearText: polyglot.t('event.entitiesAll.' + entity), action: action, clear: clear.bind(_this, [entity]), labelKey: 'name' })
        );
      }
    })
  );
}

Filters.contextTypes = {
  polyglot: _react.PropTypes.object
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Filters.js
// module id = 1166
// module chunks = 0